import { render } from "./CarouSel.vue?vue&type=template&id=b34424d0"
import script from "./CarouSel.vue?vue&type=script&lang=js"
export * from "./CarouSel.vue?vue&type=script&lang=js"

import "./CarouSel.vue?vue&type=style&index=0&id=b34424d0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__